module.exports = __webpack_public_path__ + "img/1541798932.dd515a49.jpg";